import { config } from '@/config'

const API_BASE_URL = config.apiUrl

async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

  const data = await response.json()

  if (!response.ok) {
    throw new Error(data.error || '请求失败')
  }

  return data
}

export const api = {
  services: {
    getAll: (params?: { category?: string; is_active?: boolean }) => {
      const search = new URLSearchParams()
      if (params?.category) search.set('category', params.category)
      if (params?.is_active !== undefined) search.set('is_active', String(params.is_active))
      return request(`/services${search.toString() ? `?${search.toString()}` : ''}`)
    },
    getCategories: () => request('/services/categories'),
    getById: (id: number) => request(`/services/${id}`),
    create: (data: any) => request('/services', { method: 'POST', body: JSON.stringify(data) }),
    update: (id: number, data: any) => request(`/services/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: number) => request(`/services/${id}`, { method: 'DELETE' }),
  },

  beauticians: {
    getAll: (isActive = true) => request(`/beauticians?is_active=${isActive}`),
    getById: (id: number) => request(`/beauticians/${id}`),
    getSchedule: (id: number) => request(`/beauticians/${id}/schedule`),
    getAvailableSlots: (id: number, date: string, serviceId?: number) => {
      const search = new URLSearchParams({ date })
      if (serviceId) search.set('service_id', String(serviceId))
      return request(`/beauticians/${id}/available-slots?${search.toString()}`)
    },
    create: (data: any) => request('/beauticians', { method: 'POST', body: JSON.stringify(data) }),
    update: (id: number, data: any) => request(`/beauticians/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: number) => request(`/beauticians/${id}`, { method: 'DELETE' }),
  },

  appointments: {
    getAll: (params?: { status?: string; date?: string; beautician_id?: number }) => {
      const search = new URLSearchParams()
      if (params?.status) search.set('status', params.status)
      if (params?.date) search.set('date', params.date)
      if (params?.beautician_id) search.set('beautician_id', String(params.beautician_id))
      return request(`/appointments${search.toString() ? `?${search.toString()}` : ''}`)
    },
    getById: (id: number) => request(`/appointments/${id}`),
    create: (data: {
      customer_name: string
      customer_phone: string
      customer_wechat?: string
      service_id: number
      beautician_id?: number
      appointment_date: string
      appointment_time: string
      notes?: string
    }) => request('/appointments', { method: 'POST', body: JSON.stringify(data) }),
    updateStatus: (id: number, status: string) =>
      request(`/appointments/${id}/status`, { method: 'PUT', body: JSON.stringify({ status }) }),
    update: (id: number, data: any) => request(`/appointments/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: number) => request(`/appointments/${id}`, { method: 'DELETE' }),
    checkAvailability: (params: {
      beautician_id?: number
      date: string
      time: string
      duration?: number
      exclude_id?: number
    }) => {
      const search = new URLSearchParams()
      if (params.beautician_id) search.set('beautician_id', String(params.beautician_id))
      search.set('date', params.date)
      search.set('time', params.time)
      if (params.duration) search.set('duration', String(params.duration))
      if (params.exclude_id) search.set('exclude_id', String(params.exclude_id))
      return request(`/appointments/check-availability?${search.toString()}`)
    },
  },

  admin: {
    login: (username: string, password: string) =>
      request('/admin/login', { method: 'POST', body: JSON.stringify({ username, password }) }),
    getSummary: () => request('/admin/appointments/summary'),
    changePassword: (old_password: string, new_password: string) =>
      request('/admin/change-password', { method: 'POST', body: JSON.stringify({ old_password, new_password }) }),
  },

  settings: {
    getAll: () => request('/settings'),
    get: (key: string) => request(`/settings/${key}`),
    update: (key: string, value: string) =>
      request(`/settings/${key}`, { method: 'PUT', body: JSON.stringify({ value }) }),
  },

  announcements: {
    getAll: () => request('/announcements'),
    getAllAdmin: () => request('/admin/announcements'),
    create: (data: any) => request('/announcements', { method: 'POST', body: JSON.stringify(data) }),
    update: (id: number, data: any) => request(`/announcements/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: number) => request(`/announcements/${id}`, { method: 'DELETE' }),
  },
}
